import {EntityCapsule, EntityCapsuleProps} from "../entity/capsule.tsx";
import {iconForEntityType} from "../fa.tsx";

export type WasteFlavorCapsuleProps = EntityCapsuleProps;

export function WasteFlavorCapsule(props: WasteFlavorCapsuleProps) {
    const {entity, ...rest} = props;
    if (!!entity && !entity.icon) {
        entity.icon = iconForEntityType("wasteFlavor");
    }
    return <EntityCapsule entity={entity} {...rest}/>
}